import React, { useState } from "react";
import "./ArchiveAccessGate.scss";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";

import { Logo, Title } from "../../../assets";
import { useWallet } from "../../../../contexts/WalletContext";
import { useAuth } from "../../../../contexts/AuthContext";

const ArchiveAccessGate = () => {
  const { ethAddress, provider, connectWallet } = useWallet();
  const { ethAddress: authEthAddress } = useAuth();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [matchedTokens, setMatchedTokens] = useState([]);
  const [message, setMessage] = useState("");
  const [readyToSignIn, setReadyToSignIn] = useState(false);

  const CONTRACT_ADDRESS = "0xF679A38273547875b1730Ae995a1B0d856868843";
  const ALCHEMY_API_KEY = "cBHgm4PNLXlDi1jcTDugv";
  const PUBLIC_GATEWAY = "https://funooni-public.mypinata.cloud/ipfs";

  const handleVerify = async () => {
    try {
      setLoading(true);
      setMatchedTokens([]);
      setMessage("Connecting wallet...");

      let wallet = ethAddress || authEthAddress;

      if (!wallet) {
        await connectWallet();
        wallet = ethAddress;
      }

      if (!wallet) {
        setMessage("Failed to connect wallet.");
        setLoading(false);
        return;
      }

      setMessage("Signing verification message...");

      const web3Provider = new ethers.BrowserProvider(
        provider || window.ethereum
      );
      const signer = await web3Provider.getSigner();

      const signature = await signer.signMessage(
        "Please sign this message to verify NFT ownership."
      );

      setMessage("Checking NFTs on blockchain...");

      const url = `https://base-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}/getNFTs/?owner=${wallet}&contractAddresses[]=${CONTRACT_ADDRESS}`;

      const nftRes = await fetch(url);
      const nftData = await nftRes.json();

      let list = [];

      if (nftData.ownedNfts?.length > 0) {
        list = await Promise.all(
          nftData.ownedNfts.map(async (nft) => {
            let tokenUri = nft.tokenUri?.gateway || nft.tokenUri?.raw;
            if (!tokenUri) return null;

            if (tokenUri.startsWith("ipfs://")) {
              tokenUri = `${PUBLIC_GATEWAY}/${tokenUri.replace("ipfs://", "")}`;
            }

            try {
              const metaRes = await fetch(tokenUri);
              const metadata = await metaRes.json();

              return {
                tokenId: nft.tokenId,
                title: metadata?.name || `Token #${nft.tokenId}`,
                metadata,
              };
            } catch {
              return null;
            }
          })
        );
      }

      const filtered = list.filter(Boolean);
      setMatchedTokens(filtered);

      if (filtered.length > 0) {
        setMessage(`Access Granted! Found ${filtered.length} keys.`);
      } else {
        setMessage("No Access Keys found.");
      }

      setReadyToSignIn(true);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setMessage("Verification failed.");
      setLoading(false);
    }
  };

  const handleSignIn = () => {
    setMessage("Redirecting...");
    setTimeout(() => {
      navigate("/archive_home", {
        state: {
          matchedTokens,
          walletAddress: ethAddress || authEthAddress,
          verificationPassed: matchedTokens.length > 0,
        },
      });
    }, 2000);
  };

  return (
    <div className="access-container">
      <div className="asc-flex arch-asc-flex">
        <div>
          <img className="access-icon" src={Title} alt="title" />
          <div className="dots-pattern arch-dots-pattern arch-dots-pattern2"></div>
        </div>
        <div className="dots-pattern arch-dots-pattern"></div>
      </div>

      <div className="access-card">
        <img className="access-icon" src={Logo} alt="logo" />

        {!readyToSignIn ? (
          <button
            onClick={handleVerify}
            disabled={loading}
            className="access-button"
          >
            {loading ? "Checking..." : "Connect Wallet"}
          </button>
        ) : (
          <button onClick={handleSignIn} className="access-button">
            Sign In
          </button>
        )}
      </div>

      <div className="asc-flex arch-asc-flex">
        <div className="dots-pattern arch-dots-pattern"></div>

        <div className="status-bar" style={{ display: "flex" }}>
          <div className="status-bar">
            {matchedTokens.length > 0 && (
              <div className="col-link">
                <p>Available Collections:</p>
                {matchedTokens.map((t, idx) => (
                  <p key={idx} className="access-token-line">
                    <span className="access-type">{t.title}</span>
                  </p>
                ))}
              </div>
            )}
          </div>

          <div>
            {message && <div className="info-message">{message}</div>}

            {matchedTokens.length > 0 && (
              <div className="col-link">
                <p>--- Found Keys ---</p>
                {matchedTokens.map((t, idx) => (
                  <p key={idx} className="access-token-line">
                    <span className="access-type">{t.title}</span>
                  </p>
                ))}
              </div>
            )}
          </div>
          <p className="asc-flex-p">x x x</p>
        </div>
      </div>
    </div>
  );
};

export default ArchiveAccessGate;
